module.exports = __webpack_public_path__ + "static/reindeerblanket-c596365b3b516030784bc19ec1ea4480.jpeg";